<template>
  <div class="read-instructions box-shadow-default">
    <h2 class="text-center">{{ systemName }}预约须知及协议</h2>
    <p>
      欢迎使用{{ systemName }}。<span class="red-font"
        >为方便公众申请不动产登记，现开通网上预约功能。申请人在申请前须仔细阅读本须知。</span
      >
    </p>
    <p>
      一、网上预约采取实名制，申请人必须是办理不动产登记业务的申请人或委托代理人。
    </p>
    <p>
      二、网上预约的时间为次日起至第5个工作日内（以具体开放时间为准），不能预约当天号源，节假日和休息日不接受预约。
    </p>
    <p>三、申请人在预约有效期内只能预约一次，不能重复预约。</p>
    <p>四、预约成功后，如不能按预约时间到达办理，请予预约日前一天取消预约。</p>
    <p>
      <span class="red-font">五、为防止恶意预约，系统已建立黑名单制度，如：预约后多次取消、未在约定时间内来现场办理等情况。</span>
    </p>
    <p>
      <span class="red-font">六、一个预约号只能办理一宗登记业务，目前只接受个人预约，不接受批量预约。</span>
    </p>
    <p>
      <span class="red-font"
        >七、预约成功后，申请人须持本人身份证，按照约定时间提前到达办事窗口，经核实确认后，到指定窗口办理与预约相关的业务。</span
      >
    </p>
    <p>
      <span class="red-font"
        >八、预约申请人超过预约办理起始时间未到场，视为申请人主动放弃预约服务，须现场取号按叫号顺序办理业务。</span
      >
    </p>
    <p>
      九、网上预约业务办理过程中，因申请人要件材料不完整或者业务数据不实等问题导致事项业务无法顺畅办理，敬请申请人及时予以协助配合和谅解。
    </p>
    <p>
      十、对于自然灾害、电力通讯或其他设施故障等原因，致使预约服务延迟或失效的，登记机关不承担任何责任。
      任何单位和个人不得恶意修改、变更预约服务的有关程序和内容，或利用网上预约进行有偿服务，否则由此引起一切损害后果的，须承担相应的法律责任。
    </p>
    <p>十一、本协议的解释权最终归不动产登记机关。</p>
    <div class="margin-large text-center">
      <el-checkbox name="type" v-model="check">我已阅读以上须知并同意</el-checkbox>
    </div>
    <div class="text-center margin-large">
      <el-button type="primary" size="small" :disabled="disabled" @click="next">
        下一步
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'read-instructions',
  data() {
    return {
      check: false,
      timeCount: 0,
      systemName: window.CONFIG.APP_INFO.systemName
    };
  },
  mounted() {
    const timer = setInterval(() => {
      this.timeCount--;
      if (this.timeCount <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  },
  computed: {
    disabled() {
      return !this.check || this.timeCount > 0;
    }
  },
  methods: {
    next() {
      this.$emit('next', 1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/styles/common-variables';
.read-instructions {
  margin: 20px 0;
  padding: 20px;
  background-color: #ffffff;
  font-size: 13px;
  h2 {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  p {
    margin: 0 0 10px;
    line-height: 40px;
  }
  .red-font {
    color: red;
  }
  /deep/ .el-checkbox {
    color: #333333;
    font-weight: bold;
    display: inline;
    &:last-of-type {
      margin-left: -40px;
    }
  }
  /deep/ .el-checkbox__label {
    display: inline;
  }
}
</style>
